import React from 'react';
import { FadeIn } from './FadeIn';
export function WhyWomenDont() {
  return <section className="bg-brown-900 py-12 md:py-20 relative overflow-hidden" data-id="element-268">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.4) 1px, transparent 0)',
      backgroundSize: '24px 24px'
    }} data-id="element-269" />
      <div className="max-w-3xl mx-auto px-4 md:px-6 relative z-10" data-id="element-270">
        <FadeIn data-id="element-271">
          <div className="flex justify-center mb-4 md:mb-5" data-id="element-272">
            <div className="bg-cream-50/10 p-3.5 md:p-5 rounded-2xl border border-cream-50/15" data-id="element-273">
              <svg className="w-7 h-7 md:w-9 md:h-9 text-cream-50" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" data-id="element-274">
                <rect x="3" y="4" width="14" height="17" rx="2" data-id="element-275" />
                <line x1="7" y1="9" x2="13" y2="9" data-id="element-276" />
                <line x1="7" y1="12" x2="11" y2="12" data-id="element-277" />
                <line x1="7" y1="15" x2="10" y2="15" data-id="element-278" />
                <circle cx="18" cy="16" r="3.5" data-id="element-279" />
                <line x1="20.5" y1="18.5" x2="22.5" y2="20.5" data-id="element-280" />
              </svg>
            </div>
          </div>

          <h2 className="text-2xl md:text-4xl mb-6 md:mb-8 text-center leading-snug text-white" data-id="element-281">
            Why Understanding Your Bill Matters
          </h2>

          <div className="bg-brown-800/60 backdrop-blur-sm rounded-2xl border border-brown-700 p-6 md:p-10 max-w-xs md:max-w-xl mx-auto" data-id="element-282">
            <div className="space-y-4 md:space-y-5 text-center" data-id="element-283">
              <p className="text-sm md:text-lg text-white/80 leading-relaxed" data-id="element-284">
                Professional medical billing advocates sometimes charge{' '}
                <span className="inline-block bg-terracotta-500/20 text-terracotta-400 font-bold px-2 py-0.5 rounded-md text-sm md:text-lg" data-id="element-285">
                  $100–$300
                </span>{' '}
                just to review medical statements.
              </p>
              <p className="text-sm md:text-lg text-white/80 leading-relaxed" data-id="element-286">
                This guide was created to help families learn simple steps they
                can try themselves first.
              </p>
              <div className="border-t border-white/10 pt-4 md:pt-5 mt-4 md:mt-5" data-id="element-287">
                <p className="font-semibold text-base md:text-xl text-cream-50 leading-snug" data-id="element-288">
                  Instead of paying hundreds, you can learn what to look for and
                  what questions to ask.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}